import { createSelector } from 'reselect';

export const getById = ({ userRole }) => userRole.byId;
export const getIds = ({ userRole }) => userRole.list.allIds;
export const getUserRole = (state, id) => getById(state)[id];
export const getUserRoleList = createSelector([getIds, getById], (allIds, byId) => allIds.map(id => byId[id]));
